import { forwardRef } from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/core';
import { themeGet } from 'styled-system';
import {
  Box,
  LoadingIndicator,
  LoadingIndicatorProps,
} from '@qga/roo-ui/components';

const pulse = keyframes`
 0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
`;

const Shimmer = styled(Box)`
  background-color: ${themeGet('colors.greys.alto')};
  animation: ${pulse} 2s ease-in-out infinite;
`;

const IndicatorWithRef = (
  props: {
    ref: React.ForwardedRef<HTMLElement>;
  } & LoadingIndicatorProps
) => <LoadingIndicator {...props} />;

interface ImageLoadingIndicatorProps {
  width?: string | number | string[] | number[];
  height?: string | number | string[] | number[];
  cover?: boolean;
}

export const ImageLoadingIndicator = forwardRef<
  HTMLElement,
  ImageLoadingIndicatorProps
>(({ width, height, cover = true }, ref) => {
  if ((!width && !height) || !cover)
    return <IndicatorWithRef ref={ref} size={12} color="greys.steel" />;

  const dimensions = {
    width: width ?? '100%',
    height: height ?? '100%',
  };
  return <Shimmer {...dimensions} data-testid="shimmer" />;
});

ImageLoadingIndicator.displayName = 'ImageLoadingIndicator';
